(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealObserver;
  let frame;

  const initMenu = root => {
    const panel = root.querySelector('[data-st-menu]') || document.querySelector('[data-st-menu]');
    const open = root.querySelector('[data-st-menu-open]') || document.querySelector('[data-st-menu-open]');
    const close = document.querySelector('[data-st-menu-close]');
    const overlay = document.querySelector('[data-st-overlay]');
    if (!panel || !open || !close || !overlay || open.dataset.stBound) return;

    const closePanel = returnFocus => {
      panel.classList.remove('is-open');
      document.body.classList.remove('st-panel-open');
      panel.setAttribute('aria-hidden', 'true');
      open.setAttribute('aria-expanded', 'false');
      if (returnFocus) open.focus();
    };
    const openPanel = () => {
      panel.classList.add('is-open');
      document.body.classList.add('st-panel-open');
      panel.setAttribute('aria-hidden', 'false');
      open.setAttribute('aria-expanded', 'true');
      close.focus();
    };
    open.addEventListener('click', openPanel);
    close.addEventListener('click', () => closePanel(true));
    overlay.addEventListener('click', () => closePanel(false));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) closePanel(true);
    });
    open.dataset.stBound = 'true';
  };

  const initReveal = root => {
    const nodes = root.querySelectorAll('.st-reveal:not([data-st-observed])');
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      nodes.forEach(node => node.classList.add('is-visible'));
      return;
    }
    revealObserver ||= new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }), { rootMargin: '0px 0px -7% 0px', threshold: .08 });
    nodes.forEach(node => {
      node.dataset.stObserved = 'true';
      revealObserver.observe(node);
    });
  };

  const updateScrollEffects = () => {
    frame = null;
    const y = window.scrollY;
    document.body.classList.toggle('st-scrolled', y > 45);
    if (reducedMotion.matches) return;
    document.querySelectorAll('[data-st-parallax]').forEach(node => {
      const rect = node.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
      const direction = node.hasAttribute('data-st-parallax-reverse') ? -1 : 1;
      node.style.setProperty('--st-image-shift', `${Math.max(-12, Math.min(12, progress * -18 * direction)).toFixed(2)}px`);
    });
  };

  const init = event => {
    const root = event?.target instanceof Element ? event.target : document;
    initMenu(root);
    initReveal(root);
    updateScrollEffects();
  };

  window.addEventListener('scroll', () => {
    if (!frame) frame = requestAnimationFrame(updateScrollEffects);
  }, { passive: true });
  reducedMotion.addEventListener?.('change', updateScrollEffects);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
